import React, { useEffect, useState } from 'react';
import { admin } from '../lib/api.js';

export default function BuildComments({ buildId }) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [body, setBody] = useState('');
  const [error, setError] = useState('');
  const [posting, setPosting] = useState(false);

  async function load() {
    try {
      setLoading(true);
      const r = await admin.comments.list(buildId);
      setComments(r.comments || []);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, [buildId]);

  async function submit(e) {
    e.preventDefault();
    if (!body.trim()) return;
    setPosting(true); setError('');
    try {
      await admin.comments.post(buildId, body.trim());
      setBody('');
      await load();
    } catch (e) { setError(e.message); }
    finally { setPosting(false); }
  }

  async function remove(id) {
    if (!confirm('Delete this comment?')) return;
    try { await admin.comments.delete(id); await load(); }
    catch (e) { alert(e.message); }
  }

  return (
    <div className="comments">
      <h4>Discussion</h4>
      {error && <div className="error-banner">{error}</div>}
      {loading && <div className="muted small">Loading…</div>}
      <ul className="comment-list">
        {comments.map(c => (
          <li key={c.id} className={`comment author-${c.author_kind}`}>
            <div className="comment-header">
              <strong>
                {c.author_kind === 'admin' ? '🛠 ' : '👤 '}
                {c.tester_name || c.admin_name || c.author_email || 'Anonymous'}
              </strong>
              <span className="muted small">{new Date(c.created_at).toLocaleString()}</span>
              <button className="comment-delete" onClick={() => remove(c.id)} title="Delete">×</button>
            </div>
            <p>{c.body}</p>
          </li>
        ))}
        {!loading && !comments.length && <li className="muted">No comments yet — be the first.</li>}
      </ul>

      <form onSubmit={submit} className="comment-form">
        <textarea
          value={body}
          onChange={e => setBody(e.target.value)}
          placeholder="Add a comment…"
          rows={3}
          maxLength={10000}
        />
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span className="muted small">{body.length} / 10000</span>
          <button type="submit" disabled={!body.trim() || posting}>
            {posting ? 'Posting…' : 'Post'}
          </button>
        </div>
      </form>
    </div>
  );
}
